export default __webpack_public_path__ + "static/Galileo-2cf28be322ebb414a2ceb036dd3f7f9c.webm";